<template>
    <div class="common">
        <!-- 搜索表单 -->
        <search-form :formConfig="formConfig" :source="searchData" @handleSearch="handleSearch" @search="search">
            <!-- <template slot="btns">
            <a-button class="search-btn-item btn-blue-line">导出</a-button>
        </template> -->
        </search-form>
        <div class="table-common">
            <a-table size="middle" :columns="columns" :row-key="(record, index) => index" :data-source="tableData"
                :pagination="pagination" :loading="loading" @change="handleTableChange" bordered
                :scroll="columns.length > 10 ? { x: '100%' } : {}" :locale="{ emptyText: '暂无数据' }">
                <template slot="guarantorName" slot-scope="text,record">
                    <span v-if="record.guarantorName">
                        {{ record.guarantorName }}
                    </span>
                    <span v-else>--</span>
                </template>
                <template slot="gldAmt" slot-scope="text">{{ text | splitK }}</template>
                <template slot="pyTm" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
                <template slot="exDay" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
                <template slot="pymGldInt" slot-scope="text,record">
                    <span @click="showModal(record.aplyId)" class="text-color-blue pointer">
                        {{ record.pymGldInt ? (utils.splitK(record.pymAmt) + '+' + utils.splitK(record.pymGldInt)) :
                            utils.splitK(record.pymAmt) }}
                    </span>
                </template>
                <template slot="toPymAmt" slot-scope="text,record">
                    {{ utils.splitK(record.toPymAmt) + '+' + utils.splitK(record.toPymGldInt) }}
                </template>
                <template slot="canBeModified" slot-scope="text">{{ text | gbCbmTrans }}</template>
                <template slot="odueCd" slot-scope="text">{{ text == 1 ? '是' : '否' }}</template>
                <template slot="pymAmt">
                    <a-input></a-input>
                </template>
                <template slot="openType" slot-scope="text,record">
                    <div class="spaceCenter">
                        <div v-if="record.openType">
                            <span v-if="record.openType == 0">无</span>
                            <span v-if="record.openType == 1">有</span>
                        </div>
                        <span v-else>--</span>
                    </div>
                </template>
                <template slot="operation" slot-scope="text, record">
                    <a @click="toPageDtail(record)">详情</a>
                    <a @click="toPageDtail(record)">付款通知</a>
                </template>
            </a-table>
        </div>
        <!-- 弹窗 -->
        <a-modal width="80%" title="付款明细" :visible="modalShow" :maskClosable="false" :footer="null" @cancel="modalCancel">
            <record-detail-modal :aplyId="aplyId"></record-detail-modal>
        </a-modal>

    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { recordApi, rcPtyList } from "@/api/buyrPym.js"
import recordDetailModal from "@/pages/bill-payment/record-detail-modal"
export default {
    components: {
        recordDetailModal
    },
    name: "gold-checks-record",
    data() {
        return {
            searchData: {
                pyTm: [],
                estbDay: [],
                gldId: "",
                exDay: [],
                receiver: "",
                canBeModified: "",
                tenantId: ""
            },
            formConfig: [
                {
                    prop: "pyTm",
                    type: "dateRange",
                    label: "付款日期",
                },
                {
                    prop: "exDay",
                    type: "dateRange",
                    label: "到期日期",
                },
                {
                    prop: "gldId",
                    type: "input",
                    label: "祺信编号",
                },
                {
                    prop: "receiver",
                    type: "selectSearch",
                    label: "接收方",
                    option: [],
                    searchSource: true,
                    valuePorp: "cstId",
                    valuePorpReal: "cstId",
                    labelPorp: "rcPtyNm",
                    searchHandle: "handleSearch",
                    normal: true
                },
                {
                    prop: "canBeModified",
                    type: "select",
                    label: "变更状态",
                    option: this.dict.modifiedStatus,
                    defaultProps: {
                        value: "value",
                        label: "name"
                    }
                },
                {
                    prop: "odueCd",
                    type: "select",
                    label: "是否逾期",
                    option: this.dict.yesOrNo,
                    defaultProps: {
                        value: "value",
                        label: "name"
                    }
                },

            ],
            columns: [
                {
                    title: "付款日期",
                    sorter: true,
                    width: "100px",
                    dataIndex: "pyTm",
                    scopedSlots: { customRender: "pyTm" },
                },
                {
                    title: "到期日期",
                    dataIndex: "exDay",
                    width: "100px",
                    scopedSlots: { customRender: "exDay" },
                },
                {
                    title: "祺信编号",
                    dataIndex: "gldId",
                    ellipsis: true,
                },
                {
                    title: "担保方",
                    dataIndex: "guarantorName",
                    scopedSlots: { customRender: "guarantorName" },
                },
                {
                    title: "接收方",
                    dataIndex: "rcPtyNm"
                },
                {
                    title: "祺信面额(元)",
                    dataIndex: "gldAmt",
                    sorter: true,
                    scopedSlots: { customRender: "gldAmt" }
                },
                {
                    title: "本次付款(元)",
                    dataIndex: "pymGldInt",
                    scopedSlots: { customRender: "pymGldInt" }
                },
                {
                    title: "待付金额(元)",
                    dataIndex: "toPymAmt",
                    sorter: true,
                    scopedSlots: { customRender: "toPymAmt" }
                },
                {
                    title: "变更状态",
                    dataIndex: "canBeModified",
                    scopedSlots: { customRender: "canBeModified" },
                },
                {
                    title: "是否逾期",
                    dataIndex: "odueCd",
                    scopedSlots: { customRender: "odueCd" },
                },
                {
                    title: "有无发票",
                    dataIndex: "openType",
                    width: 80,
                    scopedSlots: { customRender: "openType" },
                },
            ],
            tableData: [],
            pagination: {
                pageSize: 10,
                current: 1,
                sortField: "exDay",
                sortOrder: "ascend",
                total: 0,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['5', '10', '20', '50', '100'],
                showTotal: (total) => {
                    return `共 ${total} 条`
                }
            },
            loading: false,
            modalShow: false,
            aplyId: ""
        }
    },
    computed: {

        ...mapGetters({

            userObj: "home/getUserObj"

        })
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        handleSearch(value, data) {
            this.getDataList(value);
        },
        getDataList(value) { //下拉筛选
            // const cstIds = this.userObj.cstIds.join(",");
            rcPtyList().then((res) => {
                this.formConfig[3].option = res.data;
            })
                .catch((error) => {
                    console.log(error);
                });
        },
        search(data) {
            this.searchData = data || this.searchData;
            this.getTableData();
        },
        handleTableChange(pagination, filters, sorter) { //表格排序回调
            this.pagination = {
                current: pagination.current,
                pageSize: pagination.pageSize,
                sortField: sorter.field,
                sortOrder: sorter.order,
                total: this.pagination.total || 0,
            };
            this.getTableData();
        },
        getTableData() {
            let params = {};
            const cstIds = this.userObj.cstIds.join(",");
            params = {
                orderBy: this.pagination.sortField
                    ? `${this.pagination.sortField} ${this.pagination.sortOrder == "ascend" ? "asc" : "desc"
                    }`
                    : "",
                gldId: this.searchData.gldId,
                rcPty: this.searchData.receiver.key,
                canBeModified: this.searchData.canBeModified,
                pyTmSt: this.searchData.pyTm[0],
                pyTmEd: this.searchData.pyTm[1],
                exDaySt: this.searchData.exDay[0],
                exDayEd: this.searchData.exDay[1],
                odueCd: this.searchData.odueCd,
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize
            };
            this.loading = true;
            recordApi(params)
                .then((res) => {
                    this.pagination.total = res.data.grid.total;
                    this.tableData = res.data.grid.list;
                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
        },
        showModal(aplyId) {
            this.aplyId = aplyId;
            this.modalShow = true;
        },
        modalCancel(e) {
            this.modalShow = false;
        }

    },
    activated() {

    }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/pages/bill-payment/gold-checks-record.vue